import React from 'react';
import { find } from 'lodash';
import { createContextForController } from 'react-controller-context';
import { addCourseEnrolleeToEnrollees } from '../utilities/add-course-enrollee-to-enrollees';

const useController = () => {
    const [ courseEnrollees, setCourseEnrollees ] = React.useState([]);

    const getCourseEnrolleeCount = React.useCallback((course) => {
        return course.enrolled + courseEnrollees.filter( e => e.courseId === course.id).length;
    }, [courseEnrollees]);

    const setStudentCourseId = React.useCallback((student, courseId) => {
        setCourseEnrollees(addCourseEnrolleeToEnrollees(courseId, student?.id));
    }, [courseEnrollees]);

    const getStudentCourseId = React.useCallback((student) => {
        const courseEnrollee = find(courseEnrollees, { userId: student.id });
        return courseEnrollee?.courseId;
    }, [courseEnrollees]);

    return {
        courseEnrollees,
        setCourseEnrollees,
        getCourseEnrolleeCount,
        setStudentCourseId,
        getStudentCourseId
    };
};

const courseEnrolleesContext = createContextForController(useController);
export const useCourseEnrollees = courseEnrolleesContext.useController;
export const CourseEnrolleesProvider = courseEnrolleesContext.Provider;
